import { useTranslation } from 'react-i18next';

import * as St from './SlabViewerContentText.styles';

interface SlabViewerContentTextProps {
  materialName: string;
}

const SlabViewerContentText = ({
  materialName,
}: SlabViewerContentTextProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <St.Container>
      {t('SCROLLABLE_AREA.COLOR.VIEW_SLAB.INFO_MESSAGE', {
        material: materialName.toLowerCase(),
      })}
    </St.Container>
  );
};

export default SlabViewerContentText;
